(function () {
  var uid = 0;
  var PHOTON_TIMEOUT = 3000;
  var FLAG_TIMEOUT = 3000;
  var US_NAMES = ['united states', 'united states of america', 'usa', 'us', 'etats-unis', 'vereinigte staaten', 'verenigde staten'];
  var DE_NAMES = ['germany', 'deutschland', 'allemagne', 'duitsland', 'de'];
  var DIAL_PREFERRED = { '1': 'US', '7': 'RU', '39': 'IT', '44': 'GB', '61': 'AU', '212': 'MA', '262': 'RE', '358': 'FI', '590': 'GP', '599': 'CW' };
  var PHONE_ALIASES = {
    'united states': 'US', 'united states of america': 'US', 'usa': 'US', 'us': 'US',
    'etats-unis': 'US', 'vereinigte staaten': 'US', 'verenigde staten': 'US',
    'united kingdom': 'GB', 'great britain': 'GB', 'uk': 'GB', 'gb': 'GB', 'england': 'GB',
    'vereinigtes konigreich': 'GB', 'royaume-uni': 'GB', 'verenigd koninkrijk': 'GB',
    'germany': 'DE', 'deutschland': 'DE', 'allemagne': 'DE', 'duitsland': 'DE',
    'france': 'FR', 'frankreich': 'FR', 'frankrijk': 'FR',
    'netherlands': 'NL', 'nederland': 'NL', 'niederlande': 'NL', 'pays-bas': 'NL', 'holland': 'NL',
    'switzerland': 'CH', 'schweiz': 'CH', 'suisse': 'CH', 'zwitserland': 'CH'
  };

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }

  function highlightMatch(text, query) {
    var safe = escapeHtml(text);
    var needle = (query || '').trim();
    if (!needle) return safe;
    var index = text.toLowerCase().indexOf(needle.toLowerCase());
    if (index === -1) return safe;
    return escapeHtml(text.slice(0, index)) +
      '<strong>' + escapeHtml(text.slice(index, index + needle.length)) + '</strong>' +
      escapeHtml(text.slice(index + needle.length));
  }

  function unique(items) {
    var seen = {};
    return items.filter(function (item) {
      var key = (item.label || '').toLowerCase();
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function fetchJsonTimed(url, timeoutMs, externalSignal) {
    var controller = window.AbortController ? new AbortController() : null;
    var timedOut = false;
    var timer = setTimeout(function () {
      timedOut = true;
      if (controller) controller.abort();
    }, timeoutMs || PHOTON_TIMEOUT);
    if (externalSignal && controller) {
      if (externalSignal.aborted) controller.abort();
      else externalSignal.addEventListener('abort', function () { controller.abort(); });
    }
    return fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (response) {
        if (!response.ok) throw new Error('http-' + response.status);
        return response.json();
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') error.hdTimedOut = timedOut;
        throw error;
      })
      .finally(function () { clearTimeout(timer); });
  }

  function pingFlag(iso, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var done = false;
      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        img.onload = img.onerror = null;
        reject(new Error('timeout'));
      }, timeoutMs || FLAG_TIMEOUT);
      img.onload = function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        if (!img.naturalWidth) reject(new Error('invalid'));
        else resolve(true);
      };
      img.onerror = function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        reject(new Error('error'));
      };
      img.src = 'https://flagcdn.com/24x18/' + String(iso || 'gb').toLowerCase() + '.png';
    });
  }

  function optionLabel(option) {
    return (option.textContent || option.label || option.value || '').trim();
  }

  function isUnitedStates(name) {
    return US_NAMES.indexOf((name || '').trim().toLowerCase()) !== -1;
  }

  function isGermany(name) {
    return DE_NAMES.indexOf((name || '').trim().toLowerCase()) !== -1;
  }

  function findCountry(countries, query) {
    if (!query) return null;
    var needle = query.trim().toLowerCase();
    return countries.find(function (country) {
      return country.label.toLowerCase() === needle || country.value.toLowerCase() === needle;
    }) || countries.find(function (country) {
      return country.label.toLowerCase().indexOf(needle) === 0;
    }) || countries.find(function (country) {
      var label = country.label.toLowerCase();
      return label.indexOf(needle) !== -1 || needle.indexOf(label) !== -1;
    }) || null;
  }

  function toggleNamedField(form, selector, show) {
    if (!form) return;
    var box = form.querySelector(selector);
    if (!box) return;
    var input = box.querySelector('input');
    box.hidden = !show;
    if (!input) return;
    if (show) {
      input.required = box.hasAttribute('data-required-when-visible');
      input.disabled = false;
    } else {
      input.required = false;
      input.value = '';
      input.disabled = true;
    }
  }

  function toggleCountryFields(form, countryName) {
    toggleNamedField(form, '[data-hd-state-field]', isUnitedStates(countryName));
    toggleNamedField(form, '[data-hd-apartment-field]', !isGermany(countryName));
  }

  function initCountryCombobox(root) {
    if (!root || root.dataset.hdCountryReady === '1') return;
    var select = root.querySelector('.hd-country-combobox__native');
    var control = root.querySelector('.hd-country-combobox__control');
    var input = root.querySelector('.hd-country-combobox__input');
    var list = root.querySelector('.hd-country-combobox__list');
    var label = root.querySelector('.hd-country-combobox__label');
    if (!select || !control || !input || !list) return;

    var countries = Array.prototype.slice.call(select.options)
      .filter(function (option) { return option.value; })
      .map(function (option) {
        return { value: option.value, label: optionLabel(option) };
      });
    if (!countries.length) return;

    root.dataset.hdCountryReady = '1';
    uid += 1;
    var inputId = 'hd-country-input-' + uid;
    var listId = 'hd-country-list-' + uid;
    input.id = inputId;
    list.id = listId;
    input.setAttribute('aria-controls', listId);
    if (label) label.setAttribute('for', inputId);

    var form = root.closest('form');
    var emptyText = root.getAttribute('data-empty') || '';
    var requiredText = root.getAttribute('data-required') || '';
    var currentName = (root.getAttribute('data-current-country') || '').trim();
    var selected = findCountry(countries, currentName) || findCountry(countries, select.value);
    if (selected) {
      select.value = selected.value;
      input.value = selected.label;
    }
    toggleCountryFields(form, input.value || select.value);

    var isOpen = false;
    var activeIndex = -1;
    var visible = countries.slice();

    function setActive(index) {
      var options = list.querySelectorAll('[role="option"]');
      activeIndex = index;
      options.forEach(function (option, i) {
        var on = i === index;
        option.classList.toggle('is-active', on);
        option.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) {
          var top = option.offsetTop;
          var bottom = top + option.offsetHeight;
          if (top < list.scrollTop) list.scrollTop = top;
          else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
        }
      });
      if (index >= 0 && options[index]) input.setAttribute('aria-activedescendant', options[index].id);
      else input.removeAttribute('aria-activedescendant');
    }

    function render(query) {
      var needle = (query || '').trim().toLowerCase();
      visible = countries.filter(function (country) {
        return !needle || country.label.toLowerCase().indexOf(needle) !== -1;
      });
      list.innerHTML = '';
      if (!visible.length) {
        var empty = document.createElement('li');
        empty.className = 'hd-country-combobox__empty';
        empty.textContent = emptyText;
        list.appendChild(empty);
        setActive(-1);
        return;
      }
      visible.forEach(function (country, i) {
        var item = document.createElement('li');
        item.id = listId + '-opt-' + i;
        item.className = 'hd-country-combobox__option';
        item.setAttribute('role', 'option');
        item.setAttribute('data-value', country.value);
        item.textContent = country.label;
        if (select.value === country.value) item.classList.add('is-selected');
        list.appendChild(item);
      });
      var selectedIndex = visible.findIndex(function (country) { return country.value === select.value; });
      setActive(selectedIndex >= 0 ? selectedIndex : 0);
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      root.classList.add('is-open');
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      render(input.value === (selected && selected.label) ? '' : input.value);
      requestAnimationFrame(function () { input.select(); });
    }

    function close(restore) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      if (restore && selected) input.value = selected.label;
      else if (restore) input.value = '';
    }

    function choose(country) {
      if (!country) return;
      selected = country;
      select.value = country.value;
      input.value = country.label;
      input.setCustomValidity('');
      toggleCountryFields(form, country.value);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      if (form) {
        form.dispatchEvent(new CustomEvent('hd-country:change', { bubbles: true, detail: { name: country.value } }));
      }
      close(false);
    }

    function commitTypedValue() {
      var match = findCountry(countries, input.value);
      if (match) choose(match);
      else if (selected) input.value = selected.label;
      else input.value = '';
    }

    control.hidden = false;
    root.classList.add('is-enhanced');
    select.required = false;
    select.removeAttribute('required');
    input.required = true;
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    input.addEventListener('focus', open);
    input.addEventListener('click', open);
    input.addEventListener('input', function () {
      open();
      render(input.value);
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!isOpen) open();
        else setActive(Math.min(activeIndex + 1, visible.length - 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (!isOpen) open();
        else setActive(Math.max(activeIndex - 1, 0));
      } else if (event.key === 'Enter') {
        if (isOpen && visible[activeIndex]) {
          event.preventDefault();
          choose(visible[activeIndex]);
        }
      } else if (event.key === 'Escape') {
        close(true);
        input.blur();
      } else if (event.key === 'Tab') {
        commitTypedValue();
        close(false);
      }
    });
    input.addEventListener('blur', function () {
      setTimeout(function () {
        if (!root.contains(document.activeElement)) {
          commitTypedValue();
          close(false);
        }
      }, 120);
    });
    list.addEventListener('mousedown', function (event) {
      var option = event.target.closest('[role="option"]');
      if (!option) return;
      event.preventDefault();
      choose(findCountry(countries, option.getAttribute('data-value')));
    });
    if (form) {
      form.addEventListener('submit', function (event) {
        commitTypedValue();
        if (!select.value) {
          event.preventDefault();
          input.setCustomValidity(requiredText);
          input.reportValidity();
          open();
        }
      });
    }
  }

  function formatSuggestion(props) {
    var street = [props.housenumber, props.street || props.name].filter(Boolean).join(' ').trim();
    var city = props.city || props.town || props.village || props.locality || props.county || '';
    var postcode = props.postcode || '';
    var state = props.state || '';
    var country = props.country || '';
    var label = [street, city, postcode, country].filter(Boolean).join(', ');
    return {
      label: label,
      street: street,
      city: city,
      postcode: postcode,
      state: state,
      country: country,
      countrycode: (props.countrycode || '').toUpperCase()
    };
  }

  function initAddressAutocomplete(root) {
    if (!root || root.dataset.hdAddressReady === '1') return;
    var input = root.querySelector('.hd-address-autocomplete__input');
    var list = root.querySelector('.hd-address-autocomplete__list');
    var panel = root.querySelector('.hd-address-autocomplete__panel');
    var closeBtn = root.querySelector('.hd-address-autocomplete__close');
    if (!input || !list || !panel) return;
    root.dataset.hdAddressReady = '1';

    var form = root.closest('form');
    var lang = root.getAttribute('data-lang') || 'en';
    var emptyText = root.getAttribute('data-empty') || '';
    var debounceTimer = null;
    var abortController = null;
    var lookupDisabled = false;
    var suggestions = [];
    var activeIndex = -1;

    function disableAddressLookup() {
      if (lookupDisabled) return;
      lookupDisabled = true;
      root.classList.add('is-manual');
      closePanel();
      clearTimeout(debounceTimer);
      if (abortController) abortController.abort();
      input.removeAttribute('aria-expanded');
      input.removeAttribute('aria-controls');
      input.removeAttribute('aria-autocomplete');
      var icon = root.querySelector('.hd-address-autocomplete__icon');
      if (icon) icon.hidden = true;
    }

    function setActive(index) {
      var options = list.querySelectorAll('[role="option"]');
      activeIndex = index;
      options.forEach(function (option, i) {
        option.classList.toggle('is-active', i === index);
      });
    }

    function closePanel() {
      root.classList.remove('is-open');
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function render(items, query) {
      suggestions = items || [];
      list.innerHTML = '';
      if (!suggestions.length) {
        var empty = document.createElement('li');
        empty.className = 'hd-address-autocomplete__empty';
        empty.textContent = emptyText;
        list.appendChild(empty);
        setActive(-1);
      } else {
        suggestions.forEach(function (item, i) {
          var option = document.createElement('li');
          option.className = 'hd-address-autocomplete__option';
          option.setAttribute('role', 'option');
          option.setAttribute('data-index', String(i));
          option.innerHTML = highlightMatch(item.label, query);
          list.appendChild(option);
        });
        setActive(0);
      }
      panel.hidden = false;
      root.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function choose(item) {
      if (!item) return;
      input.value = item.street || item.label;
      if (form) {
        var city = form.querySelector('[name="contact[city]"]');
        var zip = form.querySelector('[name="contact[zip_code]"]');
        var state = form.querySelector('[name="contact[state]"]');
        var countryInput = form.querySelector('.hd-country-combobox__input');
        var countrySelect = form.querySelector('.hd-country-combobox__native');
        if (city && item.city) city.value = item.city;
        if (zip && item.postcode) zip.value = item.postcode;
        if (countrySelect && item.country) {
          var options = Array.prototype.slice.call(countrySelect.options);
          var match = options.find(function (option) {
            var label = optionLabel(option).toLowerCase();
            return option.value.toLowerCase() === item.country.toLowerCase() || label === item.country.toLowerCase();
          });
          if (match) {
            countrySelect.value = match.value;
            if (countryInput) {
              countryInput.value = optionLabel(match);
              countryInput.dispatchEvent(new Event('blur', { bubbles: true }));
            }
            toggleCountryFields(form, match.value);
            form.dispatchEvent(new CustomEvent('hd-country:change', { bubbles: true, detail: { name: match.value } }));
          }
        }
        if (state && item.state && isUnitedStates(item.country)) state.value = item.state;
      }
      closePanel();
    }

    function search(query) {
      if (lookupDisabled) return;
      var q = (query || '').trim();
      if (q.length < 3) {
        closePanel();
        return;
      }
      if (abortController) abortController.abort();
      abortController = window.AbortController ? new AbortController() : null;
      var url = 'https://photon.komoot.io/api/?q=' + encodeURIComponent(q) + '&limit=6&lang=' + encodeURIComponent(lang);
      fetchJsonTimed(url, PHOTON_TIMEOUT, abortController.signal)
        .then(function (data) {
          if (lookupDisabled) return;
          if (!data || !Array.isArray(data.features)) throw new Error('invalid');
          render(unique(data.features.map(function (feature) {
            return formatSuggestion(feature.properties || {});
          }).filter(function (item) { return item.label; })), q);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError' && !error.hdTimedOut) return;
          disableAddressLookup();
        });
    }

    fetchJsonTimed(
      'https://photon.komoot.io/api/?q=london&limit=1&lang=' + encodeURIComponent(lang),
      PHOTON_TIMEOUT
    ).then(function (data) {
      if (!data || !Array.isArray(data.features)) throw new Error('invalid');
    }).catch(function (error) {
      if (error && error.name === 'AbortError' && !error.hdTimedOut) return;
      disableAddressLookup();
    });

    input.addEventListener('input', function () {
      if (lookupDisabled) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { search(input.value); }, 280);
    });
    input.addEventListener('keydown', function (event) {
      if (lookupDisabled || !root.classList.contains('is-open')) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(Math.min(activeIndex + 1, suggestions.length - 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(Math.max(activeIndex - 1, 0));
      } else if (event.key === 'Enter') {
        if (suggestions[activeIndex]) {
          event.preventDefault();
          choose(suggestions[activeIndex]);
        }
      } else if (event.key === 'Escape') {
        closePanel();
      }
    });
    input.addEventListener('blur', function () {
      setTimeout(function () {
        if (!root.contains(document.activeElement)) closePanel();
      }, 120);
    });
    list.addEventListener('mousedown', function (event) {
      var option = event.target.closest('[role="option"]');
      if (!option) return;
      event.preventDefault();
      choose(suggestions[Number(option.getAttribute('data-index'))]);
    });
    if (closeBtn) {
      closeBtn.addEventListener('mousedown', function (event) {
        event.preventDefault();
        closePanel();
      });
    }
  }

  function phoneCountries() {
    if (window.HD_PHONE_COUNTRIES) return window.HD_PHONE_COUNTRIES;
    window.HD_PHONE_COUNTRIES = [
      ['AF','93','Afghanistan'],['AL','355','Albania'],['DZ','213','Algeria'],['AD','376','Andorra'],
      ['AO','244','Angola'],['AR','54','Argentina'],['AM','374','Armenia'],['AU','61','Australia'],
      ['AT','43','Austria'],['AZ','994','Azerbaijan'],['BS','1','Bahamas'],['BH','973','Bahrain'],
      ['BD','880','Bangladesh'],['BB','1','Barbados'],['BY','375','Belarus'],['BE','32','Belgium'],
      ['BZ','501','Belize'],['BJ','229','Benin'],['BM','1','Bermuda'],['BO','591','Bolivia'],
      ['BA','387','Bosnia and Herzegovina'],['BW','267','Botswana'],['BR','55','Brazil'],
      ['BN','673','Brunei'],['BG','359','Bulgaria'],['BF','226','Burkina Faso'],['BI','257','Burundi'],
      ['KH','855','Cambodia'],['CM','237','Cameroon'],['CA','1','Canada'],['CV','238','Cape Verde'],
      ['CF','236','Central African Republic'],['TD','235','Chad'],['CL','56','Chile'],['CN','86','China'],
      ['CO','57','Colombia'],['KM','269','Comoros'],['CG','242','Congo'],['CD','243','Congo (DRC)'],
      ['CR','506','Costa Rica'],['CI','225','Cote dIvoire'],['HR','385','Croatia'],['CU','53','Cuba'],
      ['CY','357','Cyprus'],['CZ','420','Czechia'],['DK','45','Denmark'],['DJ','253','Djibouti'],
      ['DO','1','Dominican Republic'],['EC','593','Ecuador'],['EG','20','Egypt'],['SV','503','El Salvador'],
      ['GQ','240','Equatorial Guinea'],['ER','291','Eritrea'],['EE','372','Estonia'],['SZ','268','Eswatini'],
      ['ET','251','Ethiopia'],['FJ','679','Fiji'],['FI','358','Finland'],['FR','33','France'],
      ['GA','241','Gabon'],['GM','220','Gambia'],['GE','995','Georgia'],['DE','49','Germany'],
      ['GH','233','Ghana'],['GR','30','Greece'],['GD','1','Grenada'],['GT','502','Guatemala'],
      ['GN','224','Guinea'],['GY','592','Guyana'],['HT','509','Haiti'],['HN','504','Honduras'],
      ['HK','852','Hong Kong'],['HU','36','Hungary'],['IS','354','Iceland'],['IN','91','India'],
      ['ID','62','Indonesia'],['IR','98','Iran'],['IQ','964','Iraq'],['IE','353','Ireland'],
      ['IL','972','Israel'],['IT','39','Italy'],['JM','1','Jamaica'],['JP','81','Japan'],
      ['JO','962','Jordan'],['KZ','7','Kazakhstan'],['KE','254','Kenya'],['KW','965','Kuwait'],
      ['KG','996','Kyrgyzstan'],['LA','856','Laos'],['LV','371','Latvia'],['LB','961','Lebanon'],
      ['LS','266','Lesotho'],['LR','231','Liberia'],['LY','218','Libya'],['LI','423','Liechtenstein'],
      ['LT','370','Lithuania'],['LU','352','Luxembourg'],['MO','853','Macao'],['MG','261','Madagascar'],
      ['MW','265','Malawi'],['MY','60','Malaysia'],['MV','960','Maldives'],['ML','223','Mali'],
      ['MT','356','Malta'],['MX','52','Mexico'],['MD','373','Moldova'],['MC','377','Monaco'],
      ['MN','976','Mongolia'],['ME','382','Montenegro'],['MA','212','Morocco'],['MZ','258','Mozambique'],
      ['MM','95','Myanmar'],['NA','264','Namibia'],['NP','977','Nepal'],['NL','31','Netherlands'],
      ['NZ','64','New Zealand'],['NI','505','Nicaragua'],['NE','227','Niger'],['NG','234','Nigeria'],
      ['KP','850','North Korea'],['MK','389','North Macedonia'],['NO','47','Norway'],['OM','968','Oman'],
      ['PK','92','Pakistan'],['PS','970','Palestine'],['PA','507','Panama'],['PG','675','Papua New Guinea'],
      ['PY','595','Paraguay'],['PE','51','Peru'],['PH','63','Philippines'],['PL','48','Poland'],
      ['PT','351','Portugal'],['PR','1','Puerto Rico'],['QA','974','Qatar'],['RO','40','Romania'],
      ['RU','7','Russia'],['RW','250','Rwanda'],['SA','966','Saudi Arabia'],['SN','221','Senegal'],
      ['RS','381','Serbia'],['SC','248','Seychelles'],['SL','232','Sierra Leone'],['SG','65','Singapore'],
      ['SK','421','Slovakia'],['SI','386','Slovenia'],['SO','252','Somalia'],['ZA','27','South Africa'],
      ['KR','82','South Korea'],['SS','211','South Sudan'],['ES','34','Spain'],['LK','94','Sri Lanka'],
      ['SD','249','Sudan'],['SR','597','Suriname'],['SE','46','Sweden'],['CH','41','Switzerland'],
      ['SY','963','Syria'],['TW','886','Taiwan'],['TJ','992','Tajikistan'],['TZ','255','Tanzania'],
      ['TH','66','Thailand'],['TG','228','Togo'],['TO','676','Tonga'],['TT','1','Trinidad and Tobago'],
      ['TN','216','Tunisia'],['TR','90','Turkey'],['TM','993','Turkmenistan'],['UG','256','Uganda'],
      ['UA','380','Ukraine'],['AE','971','United Arab Emirates'],['GB','44','United Kingdom'],
      ['US','1','United States'],['UY','598','Uruguay'],['UZ','998','Uzbekistan'],['VU','678','Vanuatu'],
      ['VE','58','Venezuela'],['VN','84','Vietnam'],['YE','967','Yemen'],['ZM','260','Zambia'],
      ['ZW','263','Zimbabwe']
    ].map(function (row) {
      return { iso: row[0], dial: row[1], name: row[2] };
    });
    return window.HD_PHONE_COUNTRIES;
  }

  function flagMarkup(iso) {
    iso = (iso || '').toLowerCase();
    if (iso.length !== 2) return '';
    return '<img class="hd-phone-field__flag-img" src="https://flagcdn.com/24x18/' + iso + '.png" alt="" width="24" height="18">';
  }

  function normalizePhoneName(value) {
    return (value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function findPhoneCountry(isoOrName) {
    var countries = phoneCountries();
    var iso = (isoOrName || '').toUpperCase();
    var byIso = countries.find(function (country) { return country.iso === iso; });
    if (byIso) return byIso;
    var needle = normalizePhoneName(isoOrName);
    if (!needle) return null;
    if (PHONE_ALIASES[needle]) {
      return countries.find(function (country) { return country.iso === PHONE_ALIASES[needle]; }) || null;
    }
    return countries.find(function (country) {
      return normalizePhoneName(country.name) === needle;
    }) || countries.find(function (country) {
      var name = normalizePhoneName(country.name);
      return name.indexOf(needle) === 0 || needle.indexOf(name) === 0;
    }) || null;
  }

  function phoneDigits(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  function phoneIsEmpty(value) {
    return !phoneDigits(value);
  }

  function stripInternationalPrefix(raw) {
    var compact = String(raw || '').trim().replace(/\s/g, '');
    var digits = phoneDigits(raw);
    if (compact.charAt(0) === '+') return digits;
    if (/^00/.test(compact)) return digits.replace(/^00/, '');
    return digits;
  }

  function dialGroups() {
    if (window.HD_PHONE_DIAL_GROUPS) return window.HD_PHONE_DIAL_GROUPS;
    var groups = {};
    phoneCountries().forEach(function (country) {
      if (!groups[country.dial]) groups[country.dial] = [];
      groups[country.dial].push(country);
    });
    window.HD_PHONE_DIAL_GROUPS = groups;
    return groups;
  }

  function findCountryByNumber(value, current) {
    var raw = (value || '').trim();
    if (!raw) return null;
    var compact = raw.replace(/\s/g, '');
    var international = compact.charAt(0) === '+' || /^00\d/.test(compact);
    var digits = stripInternationalPrefix(raw);
    if (!digits) return null;
    var groups = dialGroups();
    var codes = Object.keys(groups).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < codes.length; i++) {
      var code = codes[i];
      if (digits.indexOf(code) !== 0) continue;
      if (!international && code.length < 2) continue;
      var list = groups[code];
      if (current && list.some(function (country) { return country.iso === current.iso; })) return current;
      var preferred = DIAL_PREFERRED[code];
      if (preferred) {
        var match = list.find(function (country) { return country.iso === preferred; });
        if (match) return match;
      }
      return list[0];
    }
    return null;
  }

  function initPhoneField(root) {
    if (!root || root.dataset.hdPhoneReady === '1') return;
    var input = root.querySelector('.hd-phone-field__input');
    var flagBtn = root.querySelector('.hd-phone-field__flag');
    var flagMedia = root.querySelector('.hd-phone-field__flag-media');
    var panel = root.querySelector('.hd-phone-field__panel');
    var search = root.querySelector('.hd-phone-field__search');
    var list = root.querySelector('.hd-phone-field__list');
    if (!input || !flagBtn || !panel || !list) return;

    root.dataset.hdPhoneReady = '1';
    var countries = phoneCountries();
    var form = root.closest('form');
    var emptyText = root.getAttribute('data-empty') || '';
    var userPicked = false;
    var isOpen = false;
    var flagsDisabled = false;
    var activeIndex = -1;
    var visible = countries.slice();
    var selected = findPhoneCountry(root.getAttribute('data-default-iso')) || findPhoneCountry('GB');
    if (form) {
      var countryInput = form.querySelector('.hd-country-combobox__input');
      var nativeSelect = form.querySelector('.hd-country-combobox__native');
      var fromAddress = findPhoneCountry((countryInput && countryInput.value) || (nativeSelect && nativeSelect.value));
      if (fromAddress) selected = fromAddress;
    }

    function renderFlag() {
      if (flagMedia) flagMedia.innerHTML = flagMarkup(selected.iso);
      flagBtn.setAttribute('aria-label', (root.getAttribute('data-flag-label') || '') + ', ' + selected.name + ' +' + selected.dial);
    }

    function disablePhoneEnhancements() {
      if (flagsDisabled) return;
      flagsDisabled = true;
      root.classList.add('is-manual');
      closePanel();
      if (flagBtn) flagBtn.hidden = true;
      if (panel) panel.hidden = true;
    }

    function applyCountry(country) {
      if (!country) return;
      selected = country;
      renderFlag();
    }

    function syncFlagFromNumber() {
      var match = findCountryByNumber(input.value, selected);
      if (match && match.iso !== selected.iso) {
        selected = match;
        userPicked = true;
        renderFlag();
      }
    }

    function storedPhoneValue() {
      var raw = (input.value || '').trim();
      if (!raw) return '';
      var compact = raw.replace(/\s/g, '');
      if (compact.charAt(0) === '+') return '+' + phoneDigits(raw);
      if (/^00\d/.test(compact)) return '+' + phoneDigits(raw).replace(/^00/, '');
      var match = findCountryByNumber(raw, selected);
      if (match) return '+' + phoneDigits(raw);
      return '+' + selected.dial + phoneDigits(raw);
    }

    function setActive(index) {
      var options = list.querySelectorAll('[role="option"]');
      activeIndex = index;
      options.forEach(function (option, i) {
        var on = i === index;
        option.classList.toggle('is-active', on);
        option.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) {
          var top = option.offsetTop;
          var bottom = top + option.offsetHeight;
          if (top < list.scrollTop) list.scrollTop = top;
          else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
        }
      });
    }

    function renderList(query) {
      var needle = normalizePhoneName(query);
      visible = countries.filter(function (country) {
        if (!needle) return true;
        return normalizePhoneName(country.name).indexOf(needle) !== -1 || ('+' + country.dial).indexOf(needle) !== -1 || country.dial.indexOf(needle) !== -1;
      });
      list.innerHTML = '';
      if (!visible.length) {
        var empty = document.createElement('li');
        empty.className = 'hd-phone-field__empty';
        empty.textContent = emptyText;
        list.appendChild(empty);
        setActive(-1);
        return;
      }
      visible.forEach(function (country) {
        var item = document.createElement('li');
        item.className = 'hd-phone-field__option';
        item.setAttribute('role', 'option');
        item.setAttribute('data-iso', country.iso);
        if (country.iso === selected.iso) item.classList.add('is-selected');
        item.innerHTML = '<span class="hd-phone-field__option-flag">' + flagMarkup(country.iso) + '</span>' +
          '<span class="hd-phone-field__option-name">' + escapeHtml(country.name) + '</span>' +
          '<span class="hd-phone-field__option-dial">+' + escapeHtml(country.dial) + '</span>';
        list.appendChild(item);
      });
      var selectedIndex = visible.findIndex(function (country) { return country.iso === selected.iso; });
      setActive(selectedIndex >= 0 ? selectedIndex : 0);
    }

    function closePanel() {
      if (!isOpen) return;
      isOpen = false;
      panel.hidden = true;
      root.classList.remove('is-open');
      flagBtn.setAttribute('aria-expanded', 'false');
    }

    function openPanel() {
      if (flagsDisabled) return;
      isOpen = true;
      panel.hidden = false;
      root.classList.add('is-open');
      flagBtn.setAttribute('aria-expanded', 'true');
      if (search) search.value = '';
      renderList('');
      if (search) requestAnimationFrame(function () { search.focus(); });
    }

    function chooseCountry(country) {
      if (!country) return;
      userPicked = true;
      applyCountry(country);
      closePanel();
      input.focus();
    }

    pingFlag(selected.iso, FLAG_TIMEOUT).catch(disablePhoneEnhancements);

    renderFlag();
    if (!phoneIsEmpty(input.value)) syncFlagFromNumber();

    input.addEventListener('input', function () {
      syncFlagFromNumber();
    });
    flagBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (flagsDisabled) return;
      if (isOpen) closePanel();
      else openPanel();
    });
    if (search) {
      search.addEventListener('input', function () { renderList(search.value); });
      search.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActive(Math.min(activeIndex + 1, visible.length - 1));
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(Math.max(activeIndex - 1, 0));
        } else if (event.key === 'Enter') {
          event.preventDefault();
          if (visible[activeIndex]) chooseCountry(visible[activeIndex]);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closePanel();
          flagBtn.focus();
        }
      });
    }
    list.addEventListener('mousedown', function (event) {
      var option = event.target.closest('[role="option"]');
      if (!option) return;
      event.preventDefault();
      chooseCountry(countries.find(function (country) { return country.iso === option.getAttribute('data-iso'); }));
    });
    document.addEventListener('mousedown', function (event) {
      if (!root.contains(event.target)) closePanel();
    });
    if (form) {
      form.addEventListener('hd-country:change', function (event) {
        if (userPicked || !phoneIsEmpty(input.value)) return;
        var match = findPhoneCountry(event.detail && event.detail.name);
        if (match) applyCountry(match);
      });
      form.addEventListener('submit', function () {
        if (flagsDisabled) return;
        input.value = storedPhoneValue();
      });
    }
  }

  function syncFullName(form) {
    if (!form) return;
    var first = form.querySelector('[name="contact[first_name]"]');
    var last = form.querySelector('[name="contact[last_name]"]');
    var full = form.querySelector('input[name="contact[name]"][type="hidden"]');
    if (!first || !last || !full) return;
    full.value = (first.value + ' ' + last.value).trim();
  }

  function initSampleForms() {
    document.querySelectorAll('[data-hd-country-combobox]').forEach(initCountryCombobox);
    document.querySelectorAll('[data-hd-address-autocomplete]').forEach(initAddressAutocomplete);
    document.querySelectorAll('[data-hd-phone-field]').forEach(initPhoneField);
    document.querySelectorAll('#ContactForm, form.ContactForm').forEach(function (form) {
      if (form.dataset.hdNameSync === '1') return;
      form.dataset.hdNameSync = '1';
      ['input', 'change', 'submit'].forEach(function (evt) {
        form.addEventListener(evt, function () { syncFullName(form); });
      });
      syncFullName(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSampleForms);
  } else {
    initSampleForms();
  }
  document.addEventListener('shopify:section:load', initSampleForms);
})();
